import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLoyaltyMembers = {
  name: "getLoyaltyMembers" as const,
  input: z.object({
    teamId: zExt.objectId(),
    searchQuery: z.string().optional(),
    page: z.number().min(1),
    pageSize: z.number().min(1).max(100),
  }),
  output: z.object({
    members: z.array(
      z.object({
        id: zExt.objectId(),
        name: z.string(),
        memberSince: z.string(),
        pointsBalance: z.number(),
        totalPointsEarned: z.number(),
        totalPointsRedeemed: z.number(),
        redeemedValue: z.string(),
      }),
    ),
    totalCount: z.number(),
    hasNextPage: z.boolean(),
  }),
};
